<template>
  <div class="sidebar-client">
    <div class="sidebar-client__links">
      <div class="sidebar-client__link sidebar-client__link--info">
        <img
          src="/images/icons/roles/1.svg"
          width="32"
          height="32"
          alt=""
          class="sidebar-client__link-icon">

        <span class="sidebar-client__link-title">
          {{ user.email }}
        </span>
      </div>

      <router-link
        v-for="(link, index) in links"
        :key="`link-${index}`"
        :to="link.to"
        class="sidebar-client__link"
        @click.native="handleClick(link)">
        <img
          :src="link.icon"
          width="32"
          height="32"
          alt=""
          class="sidebar-client__link-icon">

        <span class="sidebar-client__link-title">
          {{ link.title }}
        </span>
      </router-link>
    </div>

    <router-link
      :to="{ name: 'root' }"
      class="sidebar-client__catalog">
      Catalog
      <arrowhead-icon class="sidebar-client__catalog-arrow" />
    </router-link>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import ArrowheadIcon from 'Components/ui/Icons/ArrowheadIcon.vue';

export default {
  name: 'MainSidebarClientLinks',

  components: {
    ArrowheadIcon,
  },

  data() {
    return {

    };
  },

  computed: {
    ...mapState(['user']),

    links() {
      return [
        {
          title: 'My Orders',
          icon: '/images/icons/paper-list.svg',
          to: { name: 'client__orders' },
        },
        {
          title: 'Cashback',
          icon: '/images/icons/money-return.svg',
          to: { name: 'cashback' },
        },
        {
          title: 'Log out',
          icon: '/images/icons/login.svg',
          to: { name: 'root' },
          handler: this.logout,
        },
      ];
    },
  },

  methods: {
    ...mapMutations(['mutateUser']),

    handleClick(item) {
      if (item.handler) {
        item.handler();
        return;
      }

      this.$emit('hideSidebar');
    },

    async logout() {
      const { data } = await this.$axios.post('/shop/user/logout');

      if (data.info === 'ok') {
        this.mutateUser(null);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  .sidebar-client {
    padding: 0 20px;
    color: $color--basic-white;
  }

  .sidebar-client__links {
    margin: 0 -20px 24px;
  }

  .sidebar-client__link {
    display: flex;
    align-items: center;
    position: relative;
    background-color: $color--basic-menu;
    padding: 16px 20px;
    color: inherit;
    font-size: 15px;
    font-weight: 500;

    &:after {
      display: block;
      content: "";
      width: calc(100% - 40px);
      height: 1px;
      position: absolute;
      left: 20px;
      bottom: 0;
      background-color: #{rgba($color--basic-dark-gray, 0.55)};
    }

    &:last-child:after,
    &:first-child:after {
      display: none;
    }

    &--info {
      background-color: $color--basic-blue;
    }
  }

  .sidebar-client__link-icon {
    margin-right: 8px;
  }

  .sidebar-client__catalog {
    display: grid;
    grid-template-columns: 1fr 15px;
    text-transform: uppercase;
    font-size: 13px;
    background: linear-gradient(270deg, $color--basic-green 0%, $color--basic-lime 100%);
    padding: 12px;
    border-radius: 4px;
    letter-spacing: 0.1em;
    color: inherit;
    font-weight: 500;
  }

  .sidebar-client__catalog-arrow {
    --arrow-rotate: -90deg;
    --width: 10px;
  }
</style>
